module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [(!_vm.datas) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("加载中......")])]) : _vm._e(), _vm._v(" "), (_vm.datas && _vm.datas.length) ? _vm._l((_vm.datas), function(data, index) {
    return _c('tr', {
      key: index,
      class: {
        important: data.star > 2
      }
    }, [_c('td', {
      staticClass: "ushk-rili_content-time"
    }, [_vm._v(_vm._s(data.public_time))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.country) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.city))]), _vm._v(" "), _c('td', [_c('star', {
      attrs: {
        "width": data.star
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "l-cell"
    }, [(data.people) ? _c('p', {
      staticClass: "l-cell_item ushk-rili_content-img"
    }, [_c('img', {
      attrs: {
        "src": ("//cdn.jin10.com/images/flag/tx/" + (data.people) + ".png")
      }
    })]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "l-cell_item"
    }, [_vm._v("\n                        " + _vm._s(data.eventcontent) + "\n                        "), (typeof data.relates !== 'undefined' && (data.relates.news || data.relates.video || data.relates.flash)) ? _c('span', {
      staticStyle: {
        "display": "block"
      }
    }, [_vm._v("【 扩展阅读：\n                          "), (data.relates.news) ? _c('a', {
      attrs: {
        "href": ("//news.jin10.com/rili_event.html?cate=" + (data.id)),
        "target": "_blank"
      }
    }, [_vm._v("新闻 ")]) : _vm._e(), _vm._v(" "), (data.relates.video) ? _c('a', {
      attrs: {
        "href": "`//v.jin10.com/rili_event.html?cate=${data.id}`",
        "target": "_blank"
      }
    }, [_vm._v("视频 ")]) : _vm._e(), _vm._v(" "), (data.relates.flash) ? _c('a', {
      attrs: {
        "href": "`//www.jin10.com/rili_event.html?cate=${data.id}`",
        "target": "_blank"
      }
    }, [_vm._v("快讯 ")]) : _vm._e(), _vm._v("】\n                        ")]) : _vm._e()])])])])
  }) : _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("今日无财经大事")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-533e8b17","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/calendar/modules/EventsList.vue
// module id = ymDc
// module chunks = 3